var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-button',{on:{"click":_vm.createGroup}},[_vm._v("Create")]),_c('b-button',{on:{"click":_vm.deleteGroup}},[_vm._v("Delete")]),_c('b-button',{on:{"click":_vm.doIt}},[_vm._v("Do")]),_c('b-form-input',{model:{value:(_vm.groupUuid),callback:function ($$v) {_vm.groupUuid=$$v},expression:"groupUuid"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }